import axios from 'axios';
import { rest } from 'msw';
import { getInstance as getBootstrap } from 'utils/bootstrap';

function getSessionRegistrationManagerServiceUrl() {
    const bootstrap = getBootstrap();
    return bootstrap.get('sessionRegistrationManagerServiceUrl', '');
}

export default class SessionRegistrationManagerClient {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async postSessionLeave(body) {
        const baseURL = `${this.baseUrl}/session/leave`;
        const response = await axios.post(baseURL, body);

        return response.data;
    }

    async postSessionJoin(body) {
        const baseURL = `${this.baseUrl}/session/join`;
        const response = await axios.post(baseURL, body);

        return response.data;
    }
}

export const getSessionRegistrationManagerClient = () =>
    new SessionRegistrationManagerClient(getSessionRegistrationManagerServiceUrl());

export const sessionRegistrationManagerClientMockHandlers = [
    rest.post('https://services.splashdevelop.eu/session-registration-manager/session/join', (req, res, ctx) =>
        res(ctx.json({})),
    ),
    rest.post('https://services.splashdevelop.eu/session-registration-manager/session/leave', (req, res, ctx) =>
        res(ctx.json({})),
    ),
];
